<template>

  <div class="mb-5">
    
    <form @change="form_change()">
    <div class="form-row justify-content-center mx-1">
      
      <div class="col-12">
      
        <h4>Location #{{index+1}}</h4>
        <button v-if="index == 0" @click="copy()" type="button" class="btn btn-info btn-sm mb-2" style="color:#fff">Same as above</button>

       

      </div>

              <div class="col-md-12" :class="{ 'hasError': $v.form.treatment_location_site.$error }">
                  <input type="text" class="form-control my-2" placeholder="Treatment Location Name" v-model="form.treatment_location_site"  name="treatment_location_site" >
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_location_site.required">Treatment Location Name required</label>

              </div>
    </div>

            <div class="form-row justify-content-center mx-1">

              <div class="col-md-6" :class="{ 'hasError': $v.form.treatment_location_address.$error }">
                  <input type="text" class="form-control my-2" placeholder="Address" v-model="form.treatment_location_address"  name="treatment_location_address" >
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_location_address.required">Address required</label>
              </div>

               <div class="col-md-6" :class="{ 'hasError': $v.form.treatment_location_site_cross.$error }">
                <input type="text" class="form-control my-2" placeholder="Cross Streets" v-model="form.treatment_location_site_cross">
                <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_location_site_cross.required">Cross Streets required</label>
              </div>

            </div>


            <div class="form-row justify-content-center mx-1">
              
                <div class="col-md-4" :class="{ 'hasError': $v.form.treatment_location_city.$error }">
                  <input type="text" class="form-control my-2" placeholder="City" v-model="form.treatment_location_city"  name="treatment_location_city" >
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_location_city.required">City required</label>
                </div>


                <div class="col-md-2" :class="{ 'hasError': $v.form.treatment_location_state.$error }">
                  <select class="form-control my-2" v-model="form.treatment_location_state"  name="treatment_location_state">
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District Of Columbia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>


                  </select>
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_location_state.required">State required</label>
                </div>

                <div class="col-md-2" :class="{ 'hasError': $v.form.treatment_location_zip.$error }">
                  <input type="text" class="form-control my-2" placeholder="Zip code" v-model="form.treatment_location_zip">
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_location_zip.required">Zip code required</label>
                </div>

                <div class="col-md-4" :class="{ 'hasError': $v.form.treatment_location_phone.$error }">
                  <input type="text" class="form-control my-2" placeholder="Phone" v-model="form.treatment_location_phone">
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_location_phone.required">Phone required</label>
                </div>


            </div>
            <div class="form-row justify-content-center mx-1">


               <div class="col-md-3" :class="{ 'hasError': $v.form.treatment_sqfeet.$error }">
                <input type="text" class="form-control my-2" placeholder="How Many Square Feet" v-model="form.treatment_sqfeet" >
                <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_sqfeet.required">Square Feet required</label>
              </div>

              <div class="col-md-3" :class="{ 'hasError': $v.form.treatment_quote.$error }">
                <input type="text" class="form-control my-2" placeholder="Rate Quoted" v-model="form.treatment_quote" >
                <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_quote.required">Quote required</label>
              </div>

             

              <div class="col-md-3" :class="{ 'hasError': $v.form.treatment_location_onsite_contact.$error }">
                <input type="text" class="form-control my-2" placeholder="On-Site Contact" v-model="form.treatment_location_onsite_contact" >
                <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_location_onsite_contact.required">On-Site Contact required</label>
              </div>

              <div class="col-md-3" :class="{ 'hasError': $v.form.treatment_location_onsite_mobile.$error }">
                <input type="text" class="form-control my-2" placeholder="On-Site Mobile" v-model="form.treatment_location_onsite_mobile" >
                <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_location_onsite_mobile.required">On-Site Mobile required</label>
              </div>

            </div>


            <div class="form-row justify-content-center mx-1 mt-5">
              <div class="col-md-12">
                <hr>
                <h3 class="text-center my-3">Treatment Details:</h3>
                <hr>
              </div>
            </div>
            <div class="form-row justify-content-center mx-1">
              
             

              <div class="col-md-6" :class="{ 'hasError': $v.form.treatment_details_type.$error }">
                <select class="form-control my-2" v-model="form.treatment_details_type" :class="{ 'hasError': $v.form.treatment_details_type.$error }">
                      <option value="null">Commercial or Residential</option>
                      <option value="commercial">Commercial</option>
                      <option value="residential">Residential</option>
                  </select>
                 <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_details_type.required">Commercial or Residential required</label>
              </div>


              <div class="col-md-6" :class="{ 'hasError': $v.form.treatment_details_day.$error }">
                <select class="form-control my-2"   v-model="form.treatment_details_day" :class="{ 'hasError': $v.form.treatment_details_day.$error }">
                      <option value="null">Treatment Day Prefered</option>
                      <option value="monday">Monday</option>
                      <option value="tuesday">Tuesday</option>
                      <option value="wednesday">Wednesday</option>
                      <option value="thursday">Thursday</option>
                      <option value="friday">Friday</option>
                      <option value="saturday">Saturday</option>
                      <option value="sunday">Sunday</option>
                      <option value="sunday">Any Day</option>
                      <option value="sunday">Any Monday to Friday</option>
                      <option value="sunday">Weekend</option>
                  </select>
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_details_day.required">Treatment Day Prefered required</label>
              </div>


            </div>
            <div class="form-row justify-content-center mx-1">
              
              <div class="col-md-6" :class="{ 'hasError': $v.form.treatment_details_window.$error }">
                <select class="form-control my-2"  v-model="form.treatment_details_window" :class="{ 'hasError': $v.form.treatment_details_window.$error }">
                      <option value="null">Treatment Time Window Prefered</option>
                      <option value="0300-0900 | 3:00 AM - 6:00 AM">3:00 AM - 6:00 AM</option>
                      <option value="0600-0900 | 6:00 AM - 9:00 AM">6:00 AM - 9:00 AM</option>
                      <option value="0900-1200 | 9:00 AM - 12:00 PM">9:00 AM - 12:00 PM</option>
                      <option value="1200-1500 | 12:00 PM - 3:00 PM">12:00 PM - 3:00 PM</option>
                      <option value="1500-1800 | 3:00 PM - 6:00 PM">3:00 PM - 6:00 PM</option>
                      <option value="1800-2300 | 6:00 PM - 11:00 PM">6:00 PM - 11:00 PM</option>
                  </select>
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_details_window.required">Treatment Time Window Prefered required</label>
              </div>
              <div class="col-md-6" :class="{ 'hasError': $v.form.treatment_details_numbers.$error }">
              <select class="form-control my-2"  v-model="form.treatment_details_numbers" :class="{ 'hasError': $v.form.treatment_details_numbers.$error }">
                      <option value="null">Number of treatments</option>
                      <option value="1">1</option>
                      <option value="2">4</option>
                      <option value="3">6</option>
                      <option value="4">8</option>
                      <option value="4">12</option>
                  </select>
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.treatment_details_numbers.required">Number of treatments required</label>
              </div>
            </div>

            <div class="col-12 text-right" v-if="index>0">
                <button class="remove_location" type="button" @click="remove_location(index)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus-circle align-middle mr-2"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                  <span class="align-middle">REMOVE LOCATION</span>
                </button>
            </div>
      </form>
  </div>

</template>

<script>
  import location from './location'
  export default location
</script>

<style lang="css" scoped>
h4{
  color: #005cb9;
  font-family: bree,sans-serif;
  font-weight: 600;
  font-style: italic;
  font-size: 18px;
  line-height: 18px;
}

.remove_location{
  border: none;
  background: #666;
  color: #fff;
  padding: 10px 20px;
  font-size: 13px;
  line-height: 13px;
}

.hasError .invalid-feedback{
display: block !important;
color: red;
}

</style>

